import i18n from 'i18next';
import { de } from 'date-fns/locale';
import { fr } from 'date-fns/locale';
import { arSA } from 'date-fns/locale';

const INTL_LOCALE_MAP = { de: 'de-DE', fr: 'fr-FR', ar: 'ar-SA' };
const DATE_FNS_LOCALE_MAP = { de, fr, ar: arSA };

export function getIntlLocale() {
  return INTL_LOCALE_MAP[i18n.language] || INTL_LOCALE_MAP.de;
}

export function getDateFnsLocale() {
  return DATE_FNS_LOCALE_MAP[i18n.language] || DATE_FNS_LOCALE_MAP.de;
}
